import { gql } from '@apollo/client';

export const CREATE_CLIENT_COMMENT_AS_ADMIN = gql`
  mutation createClientCommentAsAdmin(
    $clientId: String!
    $comment: String!
    $appointmentId: String!
  ) {
    createClientCommentAsAdmin(
      clientId: $clientId
      comment: $comment
      appointmentId: $appointmentId
    ) {
      id
      comment
      createdAt
      createdBy
      typeOfCreatedBy
      type
      User {
        id
        name
        lastName
      }
      Appointment {
        id
        dayOfAppointment
        hourOfAppointment
      }
      Client {
        id
        name
        lastName
      }
    }
  }
`;

export const GET_ALL_CLIENT_COMMENTS_BY_APPOINTMENT = gql`
  query getAllClientCommentsByAppointment($appointmentId: String!) {
    getAllClientCommentsByAppointment(appointmentId: $appointmentId) {
      id
      comment
      createdAt
      createdBy
      type
      typeOfCreatedBy
      Appointment {
        id
        dayOfAppointment
        hourOfAppointment
      }
      User {
        id
        name
        lastName
      }
      Client {
        id
        name
        lastName
      }
    }
  }
`;

export const GET_ALL_CLIENT_COMMENTS = gql`
  query getAllClientComments($clientId: String!) {
    getAllClientComments(clientId: $clientId) {
      id
      comment
      createdAt
      createdBy
      Appointment {
        id
        dayOfAppointment
        hourOfAppointment
        Client {
          id
          name
          lastName
        }
      }
      Client {
        id
        name
        lastName
      }
    }
  }
`;
